import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, InputGroup } from 'reactstrap';
import $ from 'jquery';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux'
import { Flag } from 'flagger/react';
import DocumentTypeValidationModal from './DocumentTypeValidationModal';

class EditDocumentTypeConfigModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      lang: '',
      documentTypeModalVisible: false,
      documentTypeValidationModalVisible: false,
      fieldsarray: [],
      documentTypeConfig: {},
      description: '',
      documentType: '',
      transaction_type: '',
      scan_id: '',
      hierarchy: {},
      parentHierarchies: [{}],
      childHierarchies: [{}],
      documentTypes: [],
      folders: [],
      documentArea: '',
      includeSagePay: false
    }
    this.handlePrintDropdownChange = this.handlePrintDropdownChange.bind(this);
    this.saveDocumentType = this.saveDocumentType.bind(this);
    this.toggleDocumentTypeConfigModal = this.toggleDocumentTypeConfigModal.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.validateDocumemtType = this.validateDocumemtType.bind(this);
    this.includeSagePayCheckChange = this.includeSagePayCheckChange.bind(this);
    this.remove = this.remove.bind(this);
  }

  componentDidMount() {
    //this.getDocumentTypes();
    this.formIsLoading();
    this.getX3Folders();

    fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentType?id=' + this.props.destination)
      .then(res => res.json())
      .then(result => {
        var useSagePay
        result.Fields.forEach((field, i) => {
          var fieldObj = {
            'id': i,
            'Name': field.Name,
            'Description': field.Description.en,
            'Type': field.Type
          }

          if (field.Name.startsWith('payitnow')) {
            this.setState(prevState => ({
              fieldsarray: prevState.fieldsarray.concat(fieldObj),
              includeSagePay: true
            }))
          }
          else {
            this.setState(prevState => ({
              fieldsarray: prevState.fieldsarray.concat(fieldObj)
            }))
          }
        });

        let parentHierarchies = []
        let childHierarchies = [];

        if (result.hierarchy && result.hierarchy.parentDocTypes && result.hierarchy.parentDocTypes.length > 0) {
          parentHierarchies = [...result.hierarchy.parentDocTypes];
        } else {
          parentHierarchies.push({})
        }

        if (result.hierarchy && result.hierarchy.childDocTypes && result.hierarchy.childDocTypes.length > 0) {
          childHierarchies = [...result.hierarchy.childDocTypes];
        } else {
          childHierarchies.push({})
        }


        this.setState({
          documentType: result.DocumentType,
          destinatdocumentTypeConfigion: result,
          description: result.Description.en,
          transaction_type: result.TransactionType,
          folder: result.Folder,
          scan_id: result.ScanID,
          documentArea: result.DocumentArea,
          hierarchy: result.hierarchy || {},
          isLoading: false,
          childHierarchies,
          parentHierarchies
        })
      })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedPrintClient != this.state.selectedPrintClient) {
      this.formIsLoading();
    }

    if (this.state.folder !== prevState.folder) {
      this.setState({
        documentTypes: []
      })
      this.getDocumentTypes();
    }
  }

  formIsLoading() {
    this.setState({ isLoading: true });
  }

  getX3Folders = async () => {
    try {
      const r = await fetch(`${window.location.origin}/api/sageX3/get_x3_folders`, {
        headers: { "Accept": "application/json" }
      });

      const payload = await r.json();

      if (!r.ok) {
        console.error("get_X3_folders failed", payload);
        this.setState({ isLoading: false });
        return;
      }

      this.setState({
        folders: payload?.folders ?? [],
        isLoading: false
      });
    } catch (err) {
      console.error("get_X3_folders error", err);
      this.setState({ isLoading: false });
    }
  };
  
  getDocumentTypes = () => {
    fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentTypes?folder=' + this.state.folder)
      .then(res => res.json())
      .then(result => {
        this.setState({
          documentTypes: result
        })
      })
  }

  handleDocumentAreaDropdownChange = (event) => {
    this.setState({
      documentArea: event.target.value
    });
  }

  validateDocumemtType() {
    var valid = true;

    if (!this.state.documentType)
      valid = false;
    if (!this.state.description)
      valid = false;
    if (!this.state.transaction_type)
      valid = false;
    // if(!this.state.fieldsarray && this.state.fieldsarray.length > 0)
    //   valid = false;
    // else if(this.state.fieldsarray[0].name === "")
    //   valid = false;

    //check valid items
    if (!valid) {
      this.props.alert.error("Unable to save document type please make sure enteries are valid");
    }
    else {
      //TODO: check that the document doesn't already exist.
      this.saveDocumentType();
      this.setState({ documentTypeConfigArray: [] });
    }
  }

  saveDocumentType() {
    try {
      var bdy = {};
      bdy.id = this.props.destination;
      bdy.Name = this.state.documentType;
      bdy.Description = this.state.description;
      bdy.Fields = this.state.fieldsarray;
      bdy.Hierarchy = this.state.hierarchy;
      bdy.TransactionType = this.state.transaction_type;
      bdy.ScanID = this.state.scan_id;
      bdy.DocumentArea = this.state.documentArea;
      bdy.Folder = this.state.folder;

      // Always send these, even if they're empty arrays
      bdy.Hierarchy.childDocTypes = this.state.childHierarchies;
      bdy.Hierarchy.parentDocTypes = this.state.parentHierarchies;

      fetch(window.location.protocol + '//' + window.location.host + "/api/configuration/documentType",
        {
          method: "PUT",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bdy)
        })
        .then(res => res.json())
        .then(result => {
          this.props.alert.success("Updated document type");
          this.props.toggle()
          this.props.refresh();
        })
    }
    catch (error) {
      this.props.alert.error(error.message);
    }
  }

  handleDropdownChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handlePrintDropdownChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const id = target.id;

    var found = this.state.fieldsarray.find(element => {
      return element.id == id;
    });

    if (!this.state.fieldsarray.includes(found)) {
      var printerObj = {
        'id': this.state.fieldsarray.length,
        'Name': '',
        'Description': '',
        'Type': ''
      }

      this.setState(prevState => ({
        fieldsarray: prevState.fieldsarray.concat(printerObj)
      }))
    }
    else {
      found[name] = value;

      var newArray = this.state.fieldsarray;
      newArray.splice(id, 1, found);

      this.setState({
        fieldsarray: newArray
      })
    }
  }

  handleHierarchyCheckChange = (e) => {
    const name = e.target.name;
    const value = e.target.checked;

    let hierarchy = this.state.hierarchy;
    hierarchy[name] = value;

    this.setState({
      hierarchy: hierarchy
    })
  }

  includeSagePayCheckChange = (e) => {
    //add the specific sage pay fields
    const name = e.target.name;
    const value = e.target.checked;
    if (value) {
      //add the sage pay meta fields.

      var newArray = this.state.fieldsarray.slice();

      var payitnow_Ref = {
        'id': newArray.length,
        'Name': 'payitnow_Ref',
        'Description': 'Pay it now Reference',
        'Type': 'String'
      }
      newArray.push(payitnow_Ref);

      var payitnow_Currency = {
        'id': newArray.length,
        'Name': 'payitnow_Currency',
        'Description': 'Pay it now Currency',
        'Type': 'String'
      }
      newArray.push(payitnow_Currency);

      var payitnow_LastName = {
        'id': newArray.length,
        'Name': 'payitnow_LastName',
        'Description': 'Pay it now Last name',
        'Type': 'String'
      }
      newArray.push(payitnow_LastName);

      var payitnow_FirstName = {
        'id': newArray.length,
        'Name': 'payitnow_FirstName',
        'Description': 'Pay it now First name',
        'Type': 'String'
      }
      newArray.push(payitnow_FirstName);

      var payitnow_Value = {
        'id': newArray.length,
        'Name': 'payitnow_Value',
        'Description': 'Pay it now Value',
        'Type': 'String'
      }
      newArray.push(payitnow_Value);


      this.setState({ fieldsarray: newArray })
    }
    else {
      //remove the sage pay meta fields
      // create new array and re-assign ids on remove
      var newArray = [];
      var newid = 0;

      this.state.fieldsarray.forEach((documentTypeConfig, i) => {
        if (!documentTypeConfig.Name.startsWith('payitnow')) {
          var documentObj = {
            'id': newid,
            'Name': documentTypeConfig.Name,
            'Description': documentTypeConfig.Description,
            'Type': documentTypeConfig.Type
          }
          newArray.push(documentObj);
          newid++;
        }
      });

      this.setState({ fieldsarray: newArray })
    }

    this.setState(
      {
        includeSagePay: value
      });


  }

  toggleDocumentTypeValidationModal = () => {
    this.setState({
      documentTypeValidationModalVisible: !this.state.documentTypeValidationModalVisible
    })
  }

  toggleDocumentTypeConfigModal() {
    var newArray = this.state.fieldsarray.slice();
    var printerObj = {
      'id': this.state.fieldsarray.length,
      'Name': '',
      'Description': '',
      'Type': ''
    }
    newArray.push(printerObj);
    this.setState({ fieldsarray: newArray })
  }

  remove(id) {
    // create new array and re-assign ids on remove
    var newArray = [];
    var newid = 0;

    this.state.fieldsarray.forEach((field, i) => {
      if (i != id) {
        var printerObj = {
          'id': newid,
          'Name': field.Name,
          'Description': field.Description,
          'Type': field.Type
        }
        newArray.push(printerObj);
        newid++;
      }
    });

    this.setState({ fieldsarray: newArray })
  }

  handleParentHierarchyChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.value;
    const partsArray = value.split('!'); // Split the selected value into an array

    let hierarchy = [...this.state.parentHierarchies];

    if (partsArray.length === 2) {
      const id = partsArray[0];
      const docType = partsArray[1];

      hierarchy[i][name] = docType;
      hierarchy[i]['id'] = id;
    }
    else if (partsArray.length === 3) {
      const id = partsArray[0];
      const docType = partsArray[1];
      const field = partsArray[2];

      hierarchy[i][name] = docType;
      hierarchy[i]['id'] = id;
      hierarchy[i]['field'] = field;
    }

    this.setState({
      parentHierarchies: hierarchy
    })
  }

  handleParentHierarchyCheckChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.checked;

    let hierarchy = [...this.state.parentHierarchies];
    hierarchy[i][name] = value;

    this.setState({
      parentHierarchies: hierarchy
    })
  }

  handleChildHierarchyChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.value;
    const partsArray = value.split('!'); // Split the selected value into an array

    let hierarchy = [...this.state.childHierarchies];

     if (partsArray.length === 2) {
      const id = partsArray[0];
      const docType = partsArray[1];

      hierarchy[i][name] = docType;
      hierarchy[i]['id'] = id;
     }
     else if(partsArray.length === 3){
       const id = partsArray[0];
       const docType = partsArray[1];
       const field = partsArray[2];

       let hierarchy = [...this.state.childHierarchies];
       hierarchy[i][name] = docType;
       hierarchy[i]['id'] = id;
       hierarchy[i]['field'] = field;
     }

    this.setState({
      childHierarchies: hierarchy
    })
  }

  handleChildHierarchyCheckChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.checked;

    let hierarchy = [...this.state.childHierarchies];
    hierarchy[i][name] = value;

    this.setState({
      childHierarchies: hierarchy
    })
  }

  addParentHierarchy = () => {
    let parentHierarchies = [...this.state.parentHierarchies];

    parentHierarchies.push({})

    this.setState({
      parentHierarchies
    })
  }

  removeParentHierarchy = (i) => {
    let parentHierarchies = [...this.state.parentHierarchies];

    parentHierarchies.pop(i)

    this.setState({
      parentHierarchies
    })
  }

  addChildHierarchy = () => {
    let childHierarchies = [...this.state.childHierarchies];

    childHierarchies.push({})

    this.setState({
      childHierarchies
    })
  }

  removeChildHierarchy = (i) => {
    let childHierarchies = [...this.state.childHierarchies];

    childHierarchies.pop(i)

    this.setState({
      childHierarchies
    })
  }

  render() {

    let fields = []
    let types = []
    let hierarchyList = []
    let fieldArrayList = []
    let docTypes = [];

    let parent_hierarchies = [];
    let child_hierarchies = [];

    let parentDocTypeFields = [];
    let childDocTypeFields = [];
    let folders = [];
    let loading = <div />

    const { localisation } = this.props.userReducer;

    if (this.state.isLoading)
      loading = <Progress animated color="info" value={100} />

    if (this.state.documentTypes)
      this.state.documentTypes.forEach(docType => {
        if (this.state.hierarchy) {

          docTypes.push(
            <option
              value={`${docType._id}!${docType.DocumentType}`}>
              {docType.Description.en}</option>)
        }
      })

    if (this.state.folders)
      this.state.folders.forEach(res => { folders.push(<option selected={res.DOSSIER == this.state.folder}>{res.DOSSIER}</option>) });

    if (this.state.documentArea == 'attachment') {
      this.state.parentHierarchies.map((hierarchy, i) => (
        parent_hierarchies.push(
          <Row form>
            <Col md={5}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">{localisation['parent_document_type_text'] ? localisation['parent_document_type_text'].element_lang : 'Parent Document Type'}</Label>
                <Input type="select" name={"docType"} value={hierarchy && `${hierarchy.id}!${hierarchy.docType}`} onChange={(e) => this.handleParentHierarchyChange(e, i)}>
                  <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : ''}</option>
                  {docTypes}
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup check style={{ marginTop: '25px' }}>
                <Label for="field_description" className="s-field-title s-anchored">
                  <Input
                    type="checkbox"
                    name={'includeAttachments'}
                    onClick={this.handleHierarchyCheckChange} 
                    checked={hierarchy && hierarchy.includeAttachments} />{' '}
                  Include in email
                </Label>
              </FormGroup>
            </Col>
          </Row>
      )))

      hierarchyList.push(
        <>
          {parent_hierarchies}
          <Button size="sm" color="success" onClick={() => this.addParentHierarchy()}>+</Button>
          <div style={{ marginBottom: '10px' }} />
          
        </>
      );

    } else {
      this.state.parentHierarchies.map((hierarchy, i) => (
        parent_hierarchies.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">{localisation['parent_document_type_text'] ? localisation['parent_document_type_text'].element_lang : 'Parent Document Type'}</Label>
                <Input type="select" name={"docType"} value={hierarchy && `${hierarchy.id}!${hierarchy.docType}` } onChange={(e) => this.handleParentHierarchyChange(e, i)}>
                  <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : ''}</option>
                  {docTypes}
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="field_description" className="s-field-title s-anchored">{localisation['parent_field_name_text'] ? localisation['parent_field_name_text'].element_lang : 'Parent Field Name'}</Label>
                <Input type="select" name={"field"} value={hierarchy && hierarchy.id && hierarchy.docType && hierarchy.field ? `${hierarchy.id}!${hierarchy.docType}!${hierarchy.field}` : ''} onChange={(e) => this.handleParentHierarchyChange(e, i)}>
                  <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : ''}</option>
                  {hierarchy.docType && this.state.documentTypes.filter(dt => dt.DocumentType == hierarchy.docType)[0]?.Fields?.map(field => (
                    <option value={hierarchy.id && hierarchy.docType && field.Name ? `${hierarchy.id}!${hierarchy.docType}!${field.Name}` : ''}>{field.Description.en}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup check style={{ marginTop: '25px' }}>
                <Label for="field_description" className="s-field-title s-anchored">
                  <Input type="checkbox" checked={hierarchy && hierarchy.includeAttachments} name={'includeAttachments'} onClick={(e) => this.handleParentHierarchyCheckChange(e, i)} />{' '}
                  Include in email
                </Label>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Button id={i} className="navbtn s-fonticon-btn" outline color="danger" style={{ marginTop: '25px', padding: '3px 7px' }} onClick={() => this.removeParentHierarchy(i)}></Button>
              </FormGroup>
            </Col>
          </Row>
        )))

      this.state.childHierarchies.map((hierarchy, i) => (
        child_hierarchies.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">{localisation['child_document_type_text'] ? localisation['child_document_type_text'].element_lang : 'Child Document Type'}</Label>
                <Input type="select" name={"docType"} value={hierarchy && `${hierarchy.id}!${hierarchy.docType}`} onChange={(e) => this.handleChildHierarchyChange(e, i)}>
                  <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : ''}</option>
                  {docTypes}
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="field_description" className="s-field-title s-anchored">{localisation['child_field_name_text'] ? localisation['child_field_name_text'].element_lang : 'Child Field Name'}</Label>
                <Input type="select" name={"field"} value={hierarchy && hierarchy.id && hierarchy.docType && hierarchy.field ? `${hierarchy.id}!${hierarchy.docType}!${hierarchy.field}` : ''} onChange={(e) => this.handleChildHierarchyChange(e, i)}>
                  <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : ''}</option>
                  {hierarchy.docType && this.state.documentTypes.filter(dt => dt.DocumentType == hierarchy.docType)[0]?.Fields?.map(field => (
                    <option value={hierarchy.id && hierarchy.docType && field.Name ? `${hierarchy.id}!${hierarchy.docType}!${field.Name}` : ''}>{field.Description.en}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup check style={{ marginTop: '25px' }}>
                <Label for="field_description" className="s-field-title s-anchored">
                  <Input type="checkbox" checked={hierarchy && hierarchy.includeAttachments} name={'includeAttachments'} onClick={(e) => this.handleChildHierarchyCheckChange(e, i)} />{' '}
                  Include in email
                </Label>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Button id={i} className="navbtn s-fonticon-btn" outline color="danger" style={{ marginTop: '25px', padding: '3px 7px' }} onClick={() => this.removeChildHierarchy(i)}></Button>
              </FormGroup>
            </Col>
          </Row>
        )))

      hierarchyList.push(
        <>
          {parent_hierarchies}
          <Button size="sm" color="success" onClick={() => this.addParentHierarchy()}>+</Button>
          <div style={{ marginBottom: '10px' }} />
          {child_hierarchies}
          <Button size="sm" color="success" onClick={() => this.addChildHierarchy()}>+</Button>
        </>
      );
    }

    this.state.fieldsarray.forEach((field, i) => {
      fields = []
      types = []

      //set the known system types
      let fieldTypes = ["", "String", "Array", "Integer", "Boolean", "DateTime"];

      //add the others for a user to edit.
      fieldTypes.forEach(fieldType => {
        types.push(<option selected={fieldType == field.Type} value={fieldType}>{fieldType}</option>);
      });

      if (field.Name.startsWith("payitnow")) {
        fieldArrayList.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">{localisation['field_name'] ? localisation['field_name'].element_lang : ''}</Label>
                <Input type="text" disabled={true} name={"Name"} onChange={this.handlePrintDropdownChange} value={field.Name} id={i}>
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="field_description" className="s-field-title s-anchored">{localisation['field_description'] ? localisation['field_description'].element_lang : ''}</Label>
                <Input type="text" disabled={true} name={"Description"} onChange={this.handlePrintDropdownChange} value={field.Description} id={i}>
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="Type" className="s-field-title s-anchored">{localisation['field_type'] ? localisation['field_type'].element_lang : ''}</Label>
                <Input type="select" disabled={true} name={"Type"} onChange={this.handlePrintDropdownChange} id={i}>
                  {types}
                </Input>
              </FormGroup>
            </Col>
          </Row>)
      }
      else {
        fieldArrayList.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="Name" className="s-field-title s-anchored">{localisation['field_name'] ? localisation['field_name'].element_lang : ''}</Label>
                <Input type="text" name={"Name"} onChange={this.handlePrintDropdownChange} value={field.Name} id={i}>
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for="Description" className="s-field-title s-anchored">{localisation['field_description'] ? localisation['field_description'].element_lang : ''}</Label>
                <Input type="text" name={"Description"} onChange={this.handlePrintDropdownChange} value={field.Description} id={i}>
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="Type" className="s-field-title s-anchored">{localisation['field_type'] ? localisation['field_type'].element_lang : ''}</Label>
                <Input type="select" name={"Type"} onChange={this.handlePrintDropdownChange} id={i}>
                  {types}
                </Input>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Button id={i} className="navbtn s-fonticon-btn" outline color="danger" style={{ marginTop: '25px', padding: '3px 7px' }} onClick={() => this.remove(i)}></Button>
              </FormGroup>
            </Col>
          </Row>)
      }

    });

    let documentTypeValidationModal = <div />

    if (this.state.documentTypeValidationModalVisible)
      documentTypeValidationModal = <DocumentTypeValidationModal
        documentType={this.state.documentType}
        folder={this.state.folder}
        fields={this.state.fieldsarray}
        visible={this.state.documentTypeValidationModalVisible}
        toggle={this.toggleDocumentTypeValidationModal}
      />

    return (
      <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog'>
        <ModalHeader toggle={this.props.toggle}>{localisation['edit_doc_config_header'] ? localisation['edit_doc_config_header'].element_lang : ''}</ModalHeader>
        <ModalBody>
          <Row form>
            <Col lg={12}>
              <FormGroup>
                <Label for="documentType" className="s-field-title s-anchored">{localisation['table_header_type'] ? localisation['table_header_type'].element_lang : 'Document Type'}</Label>
                <Input type="text" disabled name={"documentType"} onChange={this.handleDropdownChange} id={"documentType"} value={this.state.documentType}>
                </Input>
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <Label for="folder" className="s-field-title s-anchored">{localisation['table_header_folder'] ? localisation['table_header_folder'].element_lang : ''}</Label>
                <Input type="select" name={"folder"} onChange={this.handleDropdownChange} id={"folder"}>
                  {folders}
                </Input>
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <Label for="description" className="s-field-title s-anchored">{localisation['table_header_desc'] ? localisation['table_header_desc'].element_lang : 'Description'}</Label>
                <Input type="text" name={"description"} onChange={this.handleDropdownChange} id={"description"} value={this.state.description}>
                </Input>
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <Label for="transaction_type" className="s-field-title s-anchored">{localisation['table_header_tran'] ? localisation['table_header_tran'].element_lang : 'Transaction Type'}</Label>
                <Input type="text" name={"transaction_type"} onChange={this.handleDropdownChange} id={"transaction_type"} value={this.state.transaction_type}>
                </Input>
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <Label for="document_area" className="s-field-title s-anchored">{localisation['table_header_doc_area'] ? localisation['table_header_doc_area'].element_lang : 'Document Area'}</Label>
                <Input type="select" name={"document_area"} onChange={this.handleDocumentAreaDropdownChange}>
                  <option selected={this.state.documentArea == "x3"} value={"x3"}>X3 Report</option>
                  <option selected={this.state.documentArea == "attachment"} value={"attachment"}>Document Attachment</option>
                  <option selected={this.state.documentArea == "scan"} value={"scan"}>Scanned Document</option>
                  <option selected={this.state.documentArea == "ocr"} value={"ocr"}>OCR Document</option>
                </Input>
              </FormGroup>
            </Col>
            {this.state.documentArea == 'scan' &&
              <Flag flag="DisplayScanID" entity={{ id: 1 }} case="on">
                <Col lg={12}>
                  <FormGroup>
                    <Label for="scan_id" className="s-field-title s-anchored">{localisation['table_header_scan_id'] ? localisation['table_header_scan_id'].element_lang : 'Scan ID'}</Label>
                    <Input type="text" name={"scan_id"} onChange={this.handleDropdownChange} id={"scan_id"} value={this.state.scan_id}>
                    </Input>
                  </FormGroup>
                </Col>
              </Flag>
            }

          </Row>
          <header class="s-h2-head-search"><div title="Hierarchy" class="s-h2-title">Document Hierarchy</div></header>
          {hierarchyList}
          <header class="s-h2-head-search"><div title="MetaFields" class="s-h2-title">{localisation['meta_fields_text'] ? localisation['meta_fields_text'].element_lang : ''}</div></header>
          <FormGroup check style={{ marginTop: '25px' }}>
            <Label for="includeSagePay" className="s-field-title s-anchored">
              <Input type="checkbox" name={'includeSagePay'} checked={this.state.includeSagePay} onClick={this.includeSagePayCheckChange} />{' '}
              Include Sage Pay
            </Label>
          </FormGroup>
          {fieldArrayList}
          {loading}
          {documentTypeValidationModal}
        </ModalBody>
        <ModalFooter>
          <Button color="success" style={{ position: 'absolute', left: '20px' }} onClick={this.toggleDocumentTypeConfigModal}>{localisation['add_field_button'] ? localisation['add_field_button'].element_lang : ''}</Button>
          <Button color="primary" style={{ position: 'absolute', left: '140px' }} onClick={this.toggleDocumentTypeValidationModal}>{localisation['test_document_button'] ? localisation['test_document_button'].element_lang : 'Test Document'}</Button>
          <Button color="primary" onClick={this.validateDocumemtType}>{localisation['save_button'] ? localisation['save_button'].element_lang : ''}</Button>
          <Button color="secondary" onClick={this.props.toggle}>{localisation['cancel_button'] ? localisation['cancel_button'].element_lang : ''}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect(state => state)(withAlert()(EditDocumentTypeConfigModal));